import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		loggedIn: false,
		user: null,
		loaderCount: 0,
		breadcrumbs: [],
		subMenuSettings: false,
		branchTypeId: null,
	},
	mutations: {
		setLoggedIn(state, value) {
			state.loggedIn = value;
		},
		setUser(state, value) {
			state.user = value;
		},
		increaseLoaderCount(state) {
			setTimeout(() => {
				state.loaderCount++;
			}, 200);
		},
		decreaseLoaderCount(state) {
			state.loaderCount--;
		},
		setBreadcrumbs(state, value) {
			state.breadcrumbs = value;
		},
		setSubMenuSettings(state, value) {
			state.subMenuSettings = value;
		},
		setBranchType(state, value) {
			state.branchTypeId = value;
		},
	},
});
